'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import SymfonywebServices from '@/components/technologies/symfony-services';
import YiiModelsOfWorking from '@/components/technologies/yii-models-of-working';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHero
                className=""
                desc="Enhance Your Business Productivity with Our Secured and Cost-Efficient Symfony Development Services!"
                alt="Symfony Development"
                title="Symfony Development"
                width={1090}
                height={604}
                path={'symfony-hero'}
                bgPath={'hero-bg-grunge-red'}
                color="red"
                isRed={true}
            >
                Symfony Development
            </TechHero>

            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="Symfony Development" />
            <ContetVideoSection title="Result-Driven Symfony Web Development for Your Customized Needs">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        Having community support of 3,00,000 developers and powering popular applications like Drupal and phpBB,
                        Symfony is a leading PHP framework for developing websites and web applications. Holding unmatched
                        potentials to streamline the tasks, it offers variant set of features like integration with CRM and ERP,
                        load balancing, session failover support, third-party library support and a lot more. Its inbuilt ORM
                        system, MVC design pattern and ready-to-use plugins makes it more robust and accessible. Apart from this,
                        Interoperability is one of the biggest strengths of Symfony.
                    </p>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        So, if your goal is to get acquainted with powerful, secured yet scalable platform to build future-proof
                        business solution, Symfony is the best choice to make.
                    </p>
                </>
            </ContetVideoSection>
            <SymfonywebServices></SymfonywebServices>

            <HireProcess
                bg="bg-symfony"
                pageTitle="Hire Custom Symfony Developers To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using Symfony."
            />
            <WhyChooseUs pageTitle="Why Clients Choose Moweb for Symfony Consulting?" />
            <YiiModelsOfWorking
                title="Engagement models to hire the best Symfony Developers"
                desc="Select from different engagement models to hire Symfony Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />

            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
